export default __webpack_public_path__ + "static/media/veqtor_llave.5c097d80.svg";